import {
  MotifButton,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { memo, SetStateAction, useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SearchInput from "@/components/SearchInput/SearchInput";
import { havingAddPermission } from "@/utility/common";
import { CREATE_BUTTON_VARIANT } from "@/components/Images/CommonImages";

interface TitleComplementProps {
  onSearch: (searchValue: string) => void;
  handleQuickSearchClear: () => void;
  searchQuery: string;
  Debtor: string[];
}

const TitleComplement = memo(
  ({ onSearch, handleQuickSearchClear, searchQuery,Debtor }: TitleComplementProps) => {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState(searchQuery);
    const { caseId } = useParams<{ caseId: string }>();
    const navigate = useNavigate();

    const handleSearchChange = useCallback(
      (event: { target: { value: SetStateAction<string> } }) => {
        setSearchValue(event.target.value);
      },
      []
    );

    const handleOnSearch = useCallback(() => {
      onSearch(searchValue);
    }, [onSearch, searchValue]);

    return (
      <div style={{rowGap:"5px"}} className="motif-row">
          <SearchInput
            aria-label="Search"
            onChange={handleSearchChange}
            onClear={handleQuickSearchClear}
            placeholder={t("global.globalPlaceholder.quickSearchPlaceHolder")}
            onFocusShow={false}
            value={searchQuery}
            onEnter={handleOnSearch}
            withOutDebounce={true}
          />

              {havingAddPermission(Debtor) && <MotifButton
                aria-label="Search Dropdown"
                id="dropdown-trigger-1"
                type="button"
                variant={CREATE_BUTTON_VARIANT}
              style={{height:"47px"}}
                onClick={() =>
                  navigate(`/case/${caseId}/debtor/create`)
                  }
              >
              
                 {t("pages.debtors.debtorCreate")}                
                
              </MotifButton>}
          
      </div>
    );
  }
);

export default TitleComplement;
